/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import { useState } from "react";
import { useTranslations } from "next-intl";
import { ChevronDown, ChevronUp } from "lucide-react";

export function FAQSection() {
  const t = useTranslations("Home");
  const [openFaq, setOpenFaq] = useState<string | null>(null);

  const toggleFaq = (id: string) => {
    setOpenFaq(openFaq === id ? null : id);
  };

  const faqSections = t.raw("faq.sections");
  const leftSections = faqSections.slice(0, Math.ceil(faqSections.length / 2));
  const rightSections = faqSections.slice(Math.ceil(faqSections.length / 2));

  const renderSection = (
    section: any,
    sectionIndex: number,
    columnOffset: number = 0
  ) => {
    const actualSectionIndex = sectionIndex + columnOffset;
    return (
      <div key={actualSectionIndex} className="space-y-4">
        <h3 className="text-lg font-semibold text-white mb-4 text-left">
          {section.title}
        </h3>
        <div className="space-y-3">
          {section.questions.map((question: any, questionIndex: number) => {
            const faqId = `${actualSectionIndex}-${questionIndex}`;
            return (
              <div
                key={faqId}
                className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 overflow-hidden hover:border-white/30 transition-all duration-300"
              >
                <button
                  onClick={() => toggleFaq(faqId)}
                  className="w-full px-4 py-3 text-left flex justify-between items-center hover:bg-white/5 transition-colors"
                >
                  <span className="font-medium text-sm text-white pr-2">
                    {question.question}
                  </span>
                  {openFaq === faqId ? (
                    <ChevronUp className="h-4 w-4 text-white flex-shrink-0" />
                  ) : (
                    <ChevronDown className="h-4 w-4 text-gray-400 flex-shrink-0" />
                  )}
                </button>
                {openFaq === faqId && (
                  <div className="px-4 pb-3">
                    <p className="text-gray-400 text-sm leading-relaxed">
                      {question.answer}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <section className="py-24 px-4 sm:px-8 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-black via-gray-900/50 to-black"></div>
      <div className="relative z-10 max-w-6xl mx-auto scroll-fade-in">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold mb-4 text-white font-[family-name:var(--font-big-shoulders)] uppercase">
            {t("faq.title")}
          </h2>
        </div>

        <div className="grid md:grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          {/* Columna Izquierda */}
          <div className="space-y-6">
            {leftSections.map((section: any, index: number) =>
              renderSection(section, index, 0)
            )}
          </div>

          {/* Columna Derecha */}
          <div className="space-y-6">
            {rightSections.map((section: any, index: number) =>
              renderSection(section, index, leftSections.length)
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
